import React from "react";
import {Button} from "primereact/button";
import {getModelNameByDataCollectionName, previewDataModelDocumentationAPI} from "../../../../api/DataModel/data-model";

const ModelVersionColumn = ({rowData}) => {
    return (
        <div className="grid">

            <div className="col-9 pb-0 ">{rowData['modelVersionName']}</div>
            <div className="col-1 pb-0">
                <Button icon="pi pi-book"
                        tooltip=" Model Documentation"
                        tooltipOptions={{position: 'top', showOnDisabled: true}}
                        onClick={async () => {
                            const dataModel = await getModelNameByDataCollectionName(rowData['name'])
                            const doc = await previewDataModelDocumentationAPI(dataModel);
                            if (doc !== undefined) {
                                const blob = new Blob([doc], {type: "application/pdf"});
                                const url = window.URL.createObjectURL(blob);
                                window.open(url, "_blank");
                            }
                        }}
                        className=" p-button-rounded-sm p-button-text"
                        style={{height: '0.5rem', width: '1.5rem', color: '#487c84'}}
                />
            </div>
        </div>
    )

}
export default ModelVersionColumn;
